var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlookCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outlook.com_icon_(2012-2019)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toxicology",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toxicological-appointment-confirmation",
    transform: "translate(-973.000000, -933.000000)",
    fill: "#0072C6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-2",
    transform: "translate(735.000000, 797.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlook.com_icon_(2012-2019)",
    transform: "translate(238.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0193668,5.14467988 L15.0193668,9.89109141 L16.6780592,10.9355208 C16.7218049,10.94828 16.8165872,10.9491918 16.860333,10.9355208 L23.9990881,6.12257924 C23.9990881,5.55297328 23.4677596,5.14467988 23.1679203,5.14467988 L15.0193668,5.14467988 Z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0193668,11.6618821 L16.5331513,12.7017545 C16.7464118,12.8585101 17.003418,12.7017545 17.003418,12.7017545 C16.7473232,12.8585101 24,8.04101175 24,8.04101175 L24,16.7646391 C24,17.7142861 23.3921167,18.1125543 22.7085902,18.1125543 L15.0184554,18.1125543 L15.0184554,11.6618821 L15.0193668,11.6618821 Z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18159048,9.47368439 C6.66575543,9.47368439 6.25472785,9.71610864 5.95124185,10.2000458 C5.64775586,10.6839829 5.49555718,11.3246755 5.49555718,12.1221237 C5.49555718,12.9314197 5.64775586,13.571201 5.95124185,14.0414676 C6.25472785,14.5126455 6.65299625,14.7468675 7.1451357,14.7468675 C7.65276843,14.7468675 8.05559368,14.5181137 8.35270009,14.0606063 C8.6498065,13.6030989 8.79927107,12.9678745 8.79927107,12.1558444 C8.79927107,11.3091823 8.65527472,10.6502622 8.36637063,10.1790843 C8.07746655,9.70881768 7.68284362,9.47368439 7.18159048,9.47368439 Z",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.73410805 L0,21.3032586 L14.1262249,24.2652089 L14.1262249,-1.61891718e-15 L0,2.73410805 Z M9.4527229,15.157895 C8.85577597,15.9434954 8.07746655,16.337207 7.11688325,16.337207 C6.18090693,16.337207 5.41900215,15.9562546 4.82934619,15.1952612 C4.24060159,14.4333564 3.94531792,13.4417865 3.94531792,12.2187289 C3.94531792,10.9273185 4.24424706,9.88288923 4.84301673,9.08544105 C5.44178639,8.28799287 6.23467772,7.88881309 7.22169073,7.88881309 C8.15402157,7.88881309 8.9086354,8.26976548 9.48370946,9.033493 C10.0596949,9.79722051 10.3476897,10.8033723 10.3476897,12.0528597 C10.348599,13.3369791 10.0496698,14.3722946 9.4527229,15.157895 Z",
    id: "path27"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookCalendarIcon);
export default __webpack_public_path__ + "static/media/outlook_calendar_icon.30970ce0ad3b5cafba50707d1d2ece2c.svg";
export { ForwardRef as ReactComponent };